import { Link, useLocation } from 'react-router-dom';
import ModalAddContent from './ModalAddContent';
import { useState } from 'react';
import AddCustomer from '../modules/customers/AddCustomer';
import ModalInviteAgent from '../modules/agents/ModalInviteAgent';

export default function MenuItemMobile({ title, icon, href, clickable, open, setOpen, realState }) {
  const location = useLocation();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openSheet, setOpenSheet] = useState(null);

  return (
    <>
      {clickable ? (
        <button
          onClick={() => {
            if (href == 'menu') {
              setOpen(!open);
            } else {
              setOpen(false);
              setIsOpenModal(true);
            }
          }}
          className={`
            ${href == 'menu' && open ? 'text-primary font-bold' : 'text-text-normal dark:text-blackFont-400'}
            flex flex-col gap-1 items-center justify-center disabled:opacity-50`}
        >
          {icon}
          <p className="text-xs dark:text-blackFont-400">{title}</p>
        </button>
      ) : realState ? (
        <Link
          to={href}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal dark:text-blackFont-400'
          } flex flex-col gap-1 items-center justify-center`}
        >
          {icon}
          <p className="text-xs dark:text-blackFont-400">{title}</p>
        </Link>
      ) : href != '/requests' ? (
        <button
          disabled={true}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal dark:text-blackFont-400'
          } flex flex-col gap-1 items-center justify-center disabled:opacity-50`}
        >
          {icon}
          <p className="text-xs dark:text-blackFont-400">{title}</p>
        </button>
      ) : (
        <Link
          to={href}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal dark:text-blackFont-400'
          } flex flex-col gap-1 items-center justify-center`}
        >
          {icon}
          <p className="text-xs dark:text-blackFont-400">{title}</p>
        </Link>
      )}
      {isOpenModal && (
        <ModalAddContent title="نوع محتوا خود را مشخص کنید" onOpenChange={setIsOpenModal} setOpenSheet={setOpenSheet} />
      )}
      {openSheet == 'customer' && <AddCustomer setShowModalAdd={setOpenSheet} />}
      {openSheet == 'agent' && <ModalInviteAgent isOpenRequest={openSheet} setIsOpenRequest={setOpenSheet} />}
    </>
  );
}
